export const PtBrLocale = {
    page: {
        txtTitle: 'SHIRITORI | Vocabulário de japonês online facilitado com o jogo しらとり',
    },
    common: {
        txtLogoAlt: 'Trem do Shiritori',
    },
    header: {
        txtLeave: 'SAIR DO JOGO',
    },
    dialog: {
        leave: {
            txtTitle: 'Sair deste jogo?',
            btnStay: 'CONTINUAR NO JOGO',
            btnLeave: 'SAIR E DESISTIR',
        },
    },
    home: {
        btnNewGame: 'NOVO JOGO',
        btnMainMenu: 'MENU PRINCIPAL',
        btnJoinGame: 'ENTRAR',
        btnReturnToGame: 'VOLTAR AO JOGO',
    },
    create: {
        headingNamePrompt: 'Como devemos te chamar?',
        placeholderName: 'Seu nome',
        btnOk: 'OK',
    },
    join: {
        placeholderName: 'Seu nome',
        placeholderGameId: 'id do jogo',
        btnJoinGame: 'ENTRAR',
    },
    configure: {
        header: 'CONFIGURAÇÃO DO JOGO',
        labelExpectedPlayers: 'Número de jogadores',
        labelBoardSize: 'Tamanho do tabuleiro',
        labelWordList: 'Lista de palavras',
        labelAllowHints: 'Permitir dicas',
        labelTurnTimer: 'Tempo por turno',
        optionNoTimer: 'Sem cronômetro',
        optionTimer: 'Cronômetro',
        unitSeconds: 's',
        btnStartGame: 'INICIAR',
        toastCreateError: 'Erro: não foi possível criar este jogo',
        toastTryAgain: 'Erro: tente novamente mais tarde.',
    },
    game: {
        lobby: {
            btnReady: 'Pronto',
            txtShareInvite: 'Compartilhe este código com seus amigos!',
            txtPlayer: 'Jogador',
            txtTeam: 'Time',
        },
        message: {
            noSuchGame: 'Este jogo não existe',
            txtLoading: 'Carregando...',
            txtCannotJoin: 'Não foi possível entrar no jogo',
        },
        gameplay: {
            board: {
                timeoutTitle: 'TEMPO',
                timeoutSubtitle: 'esgotou',
            },
            wordSearch: {
                multipleMatches: 'VÁRIAS CORRESPONDÊNCIAS!',
                yourTurn: 'SUA VEZ',
                placeholder: 'Qual palavra vamos jogar?',
                playAction: 'JOGAR',
                timerSeconds: '{{seconds}}s',
                toastNoSuchWord: 'Nenhuma palavra encontrada!',
                toastCantPlay: 'Não dá para jogar essa palavra!',
                toastPlayed: 'Jogou "{{word}}"',
                toastPlayFailed: 'Ops, não foi possível jogar essa palavra!',
                validation: {
                    syllableMismatch: 'A sílaba inicial não combina',
                    missingLastWord: 'O último turno não tem palavra',
                    wordNotInList: 'A palavra não está na lista escolhida',
                }
            },
            spectate: {
                waitingOn: 'Aguardando {{player}}',
                timeLeft: 'Tempo restante: {{seconds}}s',
            },
            endGame: {
                header: 'JOGO ENCERRADO',
                viewResults: 'VER RESULTADOS',
                statsTotalTime: 'Tempo total de jogo',
                statsSquaresFilled: 'Casas preenchidas',
                statsLongestWord: 'Palavra mais longa',
                share: 'Compartilhar',
                sharing: 'Compartilhando...',
                ariaCloseLabel: 'Fechar modal de fim de jogo',
            }
        },
    },
    footer: {
        linkHowToPlay: 'Como Jogar',
        linkPrivacyPolicy: 'Política de Privacidade',
        txtAllRightsReserved: 'Todos os direitos reservados.',
    },
    howToPlay: {
        title: 'Como jogar Shiritori しりとり (shiritori)',
        btnPlayNow: 'Jogar agora!',
        btnReturnToGame: 'Voltar ao jogo:',
        description1: 'b|Shiritori| é nossa versão online e multijogador do jogo japonês de cadeia de palavras しりとり. Monte um tabuleiro de imagens enquanto pratica vocabulário com amigos ou sozinho.',
        description2: 'Crie ou entre em um jogo, escolha o tamanho do tabuleiro, o conjunto de imagens e a lista de palavras, e corra para preencher a grade com palavras válidas antes que alguém vacile.',
        gameSetup: {
            title: 'Crie ou entre em um jogo',
            p1: 'Comece solo ou convide até 9 amigos (10 jogadores no total) com um link compartilhável ou código de jogo.',
            p2: 'Escolha as opções que quiser: tamanho do tabuleiro (3x3, 5x5, 7x7), padrão/cor de fundo, conjunto de imagens e a lista de palavras para estudar.',
            p3: 'Os amigos abrem o link, escolhem um apelido e aparecem no lobby; o jogo começa quando o número esperado de jogadores entrar.',
            p4: 'Chegadas tardias ainda podem assistir a uma partida em andamento no modo somente visualização.',
        },
        objective: {
            title: 'Objetivo',
            p1: 'Encadeie palavras para que cada nova comece com a última sílaba da anterior, preencha o tabuleiro e nunca termine uma palavra com ん.',
        },
        wordRules: {
            title: 'Palavras válidas',
            p1: 'Digite em kana ou romaji; o romaji é convertido para hiragana no lado do cliente antes da checagem.',
            p2: 'As palavras precisam estar na lista selecionada (100/1000 mais comuns, comidas, esportes etc.) e mostram o significado depois que você joga.',
            p3: 'Palavras já usadas ficam bloqueadas. Se homófonos forem permitidos, você pode escolher uma variação não usada com a imagem correta.',
            li1: 'Começa com a sílaba exigida pelo turno anterior',
            li2: 'Não termina com ん (n)',
            li3: 'Está incluída na lista escolhida',
            li4: 'Ainda não foi jogada nesta partida',
            li5: 'Usa um homófono/imagem permitido quando essa regra estiver ativada',
            p4: 'Cada jogada válida coloca sua imagem no tabuleiro em ordem, preenchendo da esquerda para a direita e de cima para baixo. e|Exemplo:_そば_→_バス|',
        },
        turnFlow: {
            title: 'Rodadas e tempo',
            p1: 'As rodadas passam pela lista de jogadores; quando você ficar ativo tem até 10 segundos a partir do momento em que vê sua vez.',
            p2: 'O Shiritori espera até o próximo jogador estar ativo (janela em foco) antes de começar a contagem, evitando reiniciar ou recarregar para pular o tempo.',
            p3: 'Digite sua palavra, veja a validação ao vivo e envie antes do prazo - envios inválidos ou atrasados encerram a partida na hora.',
        },
        boardFlow: {
            title: 'Tabuleiro, fluxo e fim',
            p1: 'O tabuleiro mostra cada palavra jogada com sua imagem, nome do jogador e número do turno, com setas indicando a ordem pelo grid.',
            p2: 'Quando for o turno de outra pessoa, você ainda vê a sílaba inicial necessária e a contagem regressiva enquanto espera.',
            p3: 'Se todos os espaços forem preenchidos com palavras válidas, o jogo termina em sucesso e mostra o tabuleiro completo para compartilhar.',
            p4: 'Se nenhuma jogada válida for enviada antes do tempo acabar, o jogo termina com um resumo de quem estourou o tempo ou jogou uma palavra inválida.',
        },
        summary: {
            title: 'Resumo',
            p1: 'Shiritori mantém shiritori rápido e visual - rodadas curtas, regras claras e imagens ajudam todo mundo a manter a cadeia.',
            p2: 'Compartilhe um link, preencha o tabuleiro e veja até onde sua cadeia de palavras chega.',
        }
    },
    bugsAndFeatures: {
        title: 'Relatos de bugs e novas features',
        p1: 'Construímos este jogo como uma maneira diferente de jogar o clássico k|しりとり.| Como uma equipe que ama jogos, estamos sempre buscando formas de melhorar e tornar a experiência mais divertida.',
        cta: {
            l1: 'Na verdade, adoraríamos se você pudesse nos ajudar ',
            a: 'compartilhando nosso jogo com seus amigos',
            l2: ' nas redes sociais!'
        },
        p2: 'Se encontrar qualquer bug ou tiver sugestões de novas funcionalidades, avise a gente!',
        bugs: {
            title: 'Bugs',
            p1: 'Relate comportamentos estranhos, erros ou bugs direto no nosso a|https://github.com/indexinteractive/|repositório_no_GitHub| . Inclua o máximo de detalhes possível, especialmente os passos para reproduzir o problema.'
        },
        features: {
            title: 'Novas funcionalidades',
            p1: 'Se tiver sugestões de novas features, melhorias ou ideias para o jogo, crie uma nova discussão na nossa página de a|https://github.com/indexinteractive/|Discussions_no_GitHub| .'
        }
    },
    share: {
        title: 'Shiritori | Vocabulário de japonês online facilitado com o jogo しらとり - SHIRITORI',
        text: 'Jogue Shiritori online com amigos ou jogadores aleatórios. Não precisa cadastrar!',
    }
};
